import { CCI_AFTER_CHECKLIST_ITEMS, CCI_CHECKLIST_ITEMS, type ChecklistItemDef } from './cciCatalog';
import type { InspectionChecklistItemRow } from '../types/database';

/** Soft completeness check for AFTER column (never blocks arrival). */
export function isAfterChecklistComplete(items: { id: string; status: string }[]): boolean {
  if (items.length < CCI_AFTER_CHECKLIST_ITEMS.length) return false;
  const byId = new Map(items.map((i) => [i.id, i]));
  return CCI_AFTER_CHECKLIST_ITEMS.every((def) => {
    const row = byId.get(def.id);
    if (!row) return false;
    if (row.status === 'na') return !!def.allowNa;
    return row.status === 'pass' || row.status === 'fail';
  });
}

export type ChecklistViewStatus = 'pass' | 'fail' | 'na' | 'unanswered';

export type ChecklistViewRow = {
  id: string;
  status: ChecklistViewStatus;
  note?: string;
};

/** Expand saved checklist rows against catalog so viewers see every item (incl. unanswered). */
export function expandChecklistAgainstCatalog(
  catalog: readonly ChecklistItemDef[],
  saved: InspectionChecklistItemRow[] | null | undefined,
): ChecklistViewRow[] {
  const byId = new Map((saved ?? []).map((r) => [r.id, r]));
  return catalog.map((def) => {
    const row = byId.get(def.id);
    if (!row) return { id: def.id, status: 'unanswered' as const };
    return {
      id: def.id,
      status: row.status,
      note: row.note?.trim() || undefined,
    };
  });
}

export function expandAfterChecklistItems(
  saved: InspectionChecklistItemRow[] | null | undefined,
): ChecklistViewRow[] {
  return expandChecklistAgainstCatalog(CCI_AFTER_CHECKLIST_ITEMS, saved);
}

export function expandBeforeChecklistItems(
  saved: InspectionChecklistItemRow[] | null | undefined,
): ChecklistViewRow[] {
  return expandChecklistAgainstCatalog(CCI_CHECKLIST_ITEMS, saved);
}
